import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MicroFrontendService } from '../services/micro-frontend.service';

@Injectable()
export class IsRemoteEntryLoadedGuard {
  constructor(private microFrontendService: MicroFrontendService) {}

  canActivate(): Observable<boolean> {
    return this.microFrontendService.isRemoteEntryLoaded$;
  }
}
